module.exports = __webpack_public_path__ + "img/trial2-3.1ed1d0c0.png";